import { render, staticRenderFns } from "./Backoffice.vue?vue&type=template&id=6e299a4b&scoped=true&"
import script from "./Backoffice.vue?vue&type=script&lang=ts&"
export * from "./Backoffice.vue?vue&type=script&lang=ts&"
import style0 from "./Backoffice.vue?vue&type=style&index=0&id=6e299a4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e299a4b",
  null
  
)

export default component.exports